export interface ThemeState {}

export const DEFAULT_THEME: ThemeState = {};
